
export class ConnectionUserInfoObj {
password: string;
userName: string;
}

